import { render, staticRenderFns } from "./PackingForm.vue?vue&type=template&id=6d6ecbf8&scoped=true&"
import script from "./PackingForm.vue?vue&type=script&lang=js&"
export * from "./PackingForm.vue?vue&type=script&lang=js&"
import style0 from "./PackingForm.vue?vue&type=style&index=0&id=6d6ecbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ecbf8",
  null
  
)

export default component.exports